import React from "react";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { companyInfo } from "@/data/mock";

export default function KolaborasiSection() {
  const openWA = () => {
    const text = `Halo, saya ingin kerja sama / informasi produk ${companyInfo.brand} (bumbushakti).`;
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent(text)}`, "_blank");
  };

  // Embed map pakai query address (tanpa perlu koordinat)
  const mapsEmbedSrc = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3962.371904042136!2d106.8328514!3d-6.7243943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69cb3a3245aba9%3A0x114846cee0ae4234!2sPT%20Sathrusi%20Komoditi%20Indonesia!5e0!3m2!1sen!2sid!4v1767755344882!5m2!1sen!2sid`;

  return (
    <section id="kontak" className="contact-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Hubungi Kami</span>
          <h2 className="section-title">
            Mari Berkolaborasi <span className="text-accent">Bersama Kami</span>
          </h2>
          <p className="section-description">
            Untuk pemesanan, katalog, kerja sama grosir/distributor, atau kebutuhan usaha, silakan hubungi tim kami.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <Card className="contact-card">
              <CardContent className="contact-card-content">
                <div className="contact-item">
                  <MapPin className="contact-icon" />
                  <div>
                    <h4 className="contact-label">Alamat</h4>
                    <p className="contact-text">{companyInfo.address}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <div>
                    <h4 className="contact-label">Telepon</h4>
                    <p className="contact-text">{companyInfo.phone}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <MessageCircle className="contact-icon" />
                  <div>
                    <h4 className="contact-label">WhatsApp</h4>
                    <p className="contact-text">{companyInfo.whatsapp.replace("62", "0")}</p>
                  </div>
                </div>

                <div className="contact-item">
                  <Mail className="contact-icon" />
                  <div>
                    <h4 className="contact-label">Email</h4>
                    <p className="contact-text">
                      {companyInfo.emailPrimary}
                      <br />
                      <span style={{ opacity: 0.8 }}>{companyInfo.emailSecondary}</span>
                    </p>
                  </div>
                </div>

                <Button onClick={openWA} className="contact-whatsapp" size="lg">
                  Chat via WhatsApp
                </Button>
              </CardContent>
            </Card>
          </div>

          <div className="contact-map">
            <iframe
              src={mapsEmbedSrc}
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: "16px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`Lokasi ${companyInfo.name}`}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
